export class BillReaderUtility {
	public utilityName: string;
	public showNameKey: boolean;
	public showReferenceNum: boolean;
	public showMeterNum: boolean;
	public accountNumFormat: string;
	public accountNumFormatHelp: string;

	constructor(billReaderUtility?: Partial<BillReaderUtility>) {
		Object.assign(this, billReaderUtility);
	}
}
